import { PROVIDE_LABEL_OPTIONS } from '@amzn/balder-client/lib/constants/exchanges';

export const myAccountLinkMap = {
  MANAGE_MY_ADDRESSES_CLICK: 1,
  MANAGE_MY_PAYMENT_CLICK: 2,
  SEARCH_ORDERS_CLICK: 3,
  RETURN_ITEMS_CLICK: 4,
  MANAGE_AD_PREFERENCES_CLICK: 5,
  MANAGE_EMAIL_PREFERENCES_CLICK: 6,
  MANAGE_ACCOUNT_INFORMATION_CLICK: 7,
  VIEW_VIP_DASHBOARD_CLICK: 8,
  VIEW_VIP_INFORMATION_CLICK: 9,
  RETURN_POLICY_CLICK: 10
};

export const SHIPPING_DURATION = {
  '3-5 Business Days': 'DURATION_DAYS_3_5',
  '2-Business Days': 'DURATION_DAYS_2',
  '1-Business Day': 'DURATION_DAYS_1',
  '3-7 Business Days': 'DURATION_DAYS_3_7',
  '5-7 Business Days': 'DURATION_DAYS_5_7',
  '5-10 Business Days': 'DURATION_DAYS_5_10'
};

export const SHIPPING_NAME = {
  'next-wow': 'NEXT_WOW',
  'second': 'SECOND',
  'next-business': 'NEXT_BUSINESS',
  'next': 'NEXT',
  'std-us-non48': 'STD_US_NON_48',
  'std-n-us': 'STD_N_US',
  'std-us-military': 'STD_US_MILITARY',
  'std-us-protect': 'STD_US_PROTECT',
  'std-us': 'STD_US'
};

export const SHIPPING_PROMISE = {
  '3-5 Business Days': 'BUSINESS_DAYS_3_5',
  '2-Business Days': 'BUSINESS_DAYS_2',
  '1-Business Day': 'BUSINESS_DAYS_1',
  '3-7 Business Days': 'BUSINESS_DAYS_3_7',
  '5-7 Business Days': 'BUSINESS_DAYS_5_7',
  '5-10 Business Days': 'BUSINESS_DAYS_5_10'
};

export const PROMISE_CHANGE_TYPE = {
  'PCE_TO_PCE': 'PCE_TO_PCE',
  'DEX_TO_DEX': 'DEX_TO_DEX',
  'DEX_TO_PCE': 'DEX_TO_PCE'
};

export const RETURN_LABEL_TYPE = {
  [PROVIDE_LABEL_OPTIONS.PRINT]: 'PRINTED_RETURN_LABEL',
  [PROVIDE_LABEL_OPTIONS.EMAIL]: 'EMAIL_RETURN_LABEL',
  [PROVIDE_LABEL_OPTIONS.LABELLESS]: 'PRINT_AT_UPS_RETURN_LABEL',
  [PROVIDE_LABEL_OPTIONS.MAIL]: 'MAIL_RETURN_LABEL',
  [PROVIDE_LABEL_OPTIONS.PICKUP]: 'PICKUP_RETURN_LABEL'
};
